import { useAtomValue } from 'jotai';
import React, { useEffect, useMemo } from 'react';
import { getVote, voteKey, votesAtom } from '../services/vote.service';

/**
 * The signed-in user's vote on an idea; sessionId picks the judging session when the hackathon has sessions.
 */
export const useVote = (hackathonId: string | undefined, ideaId: string | undefined, sessionId?: string) => {

    const [voteRequest, setVoteRequest] = React.useState<number>(0)
    useEffect(() => {
        if (hackathonId && ideaId && voteRequest >= 0) {
            getVote(hackathonId, ideaId, sessionId).catch(err => console.error(err));
        }

    }, [hackathonId, ideaId, sessionId, voteRequest])

    const reload = () => {
        setVoteRequest(voteRequest + 1)
    }

    const votes = useAtomValue(votesAtom);

    const vote = useMemo(() => {
        if (!hackathonId || !ideaId) return undefined
        return votes[voteKey(ideaId, sessionId)]
    }, [hackathonId, ideaId, sessionId, votes])


    return {
        vote,
        reload
    }
}